module.exports = __webpack_public_path__ + "img/1513595528.20d6c474.jpg";